module.exports = __webpack_public_path__ + "static/girl_eating_lobster-b7dbdd154a8c1ba935615334a09d5a69.png";